import { Injectable } from '@angular/core';
import { PushNotificationsConstants } from './push-notifications.constants';

@Injectable()
export class PushNotificationService {
  private _devUUID = '';
  private _devId = '';
  private _platform = '';
  private _token = '';
  private _vapidPublicKey: string;

  public _methodCallBack: any;

  constructor(private constants: PushNotificationsConstants) {
    // this.initialize();
  }

  public initialize(methodCallBack: any): void {
    this._methodCallBack = methodCallBack;
    this._vapidPublicKey = this.constants.getVapidPublicKey();
    if (this.validateSw()) {
      // tslint:disable-next-line:only-arrow-functions
      const swReg = this.registerSw().catch(function (error) {
        console.log('Push Service Worker registration has failed: ' + error);
      });
      // tslint:disable-next-line:only-arrow-functions
      this.subscriptionSw(swReg).catch(function (error) {
        console.log('Push Service Worker subscription has failed: ' + error);
      });
    }
  }

  public validateSw(): boolean {
    let isValid = false;
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      isValid = true;
      console.log('Service Workers is supported');
    }
    return isValid;
  }

  private registerSw() {
    // tslint:disable-next-line:only-arrow-functions
    return navigator.serviceWorker.register(this.constants.getUrlSW()).then(function (swReg) {
      if (swReg.installing) {
        console.log('Service worker installing');
      } else if (swReg.waiting) {
        console.log('Service worker installed');
      } else if (swReg.active) {
        console.log('Service worker active');
      }
      if (!swReg.showNotification) {
        console.log("Notifications aren't supported on service workers.");
      }
      return swReg;
    });
  }

  private subscriptionSw(registration) {
    const mSetSubscription = this.setSubscription;
    const global = this;
    // tslint:disable-next-line:only-arrow-functions
    return registration.then(function (swReg) {
      swReg.pushManager
        .getSubscription()
        // tslint:disable-next-line:only-arrow-functions
        .then(function (subscriptionInit) {
          if (subscriptionInit) {
            return mSetSubscription(subscriptionInit, global);
          } else {
            const options = {
              // tslint:disable-next-line:max-line-length
              applicationServerKey: !global._vapidPublicKey ? null : global.urlB64ToUint8Array(global._vapidPublicKey),
              userVisibleOnly: true,
            };
            return (
              swReg.pushManager
                .subscribe(options)
                // tslint:disable-next-line:only-arrow-functions
                .then(function (subscription) {
                  console.log(subscription);
                  return mSetSubscription(subscription, global);
                  // tslint:disable-next-line:only-arrow-functions
                })
                .catch(function (error) {
                  console.log('Unable to subscribe to push.', error);
                })
            );
          }
        });
    });
  }

  private setSubscription(subscription, global) {
    global.generateTokenForRegisterDevice(subscription);
    global.registerBroadcastListener();
  }

  // tslint:disable-next-line:member-ordering
  public generateTokenForRegisterDevice(subscription): void {
    localStorage.setItem('token', JSON.stringify(subscription));
    if (!localStorage.getItem('deviceUUID')) {
      this.generateUUID('');
    } else {
      this._devUUID = localStorage.getItem('deviceUUID');
      if (!localStorage.getItem('deviceId')) {
        this._devId = localStorage.getItem('deviceId');
      }
    }
    this._platform = '';
    this._devUUID = localStorage.getItem('deviceUUID');
    this._devId = localStorage.getItem('deviceId');

    const rawKey = subscription.getKey ? subscription.getKey('p256dh') : '';
    const key = rawKey ? btoa(String.fromCharCode.apply(null, [...new Uint8Array(rawKey)])) : '';
    const rawAuthSecret = subscription.getKey ? subscription.getKey('auth') : '';
    const authSecret = rawAuthSecret ? btoa(String.fromCharCode.apply(null, [...new Uint8Array(rawAuthSecret)])) : '';

    const tokenValue = {
      endpoint: subscription.endpoint,
      userAuth: authSecret,
      userPublicKey: key,
    };
    this._token = JSON.stringify(tokenValue);
    if (navigator.userAgent.indexOf('Firefox') !== -1) {
      this._platform = 'F'; // Firefox Browser
    } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
      this._platform = 'C'; // Chrome Browser
    }

    let device = null;
    if (this.validateInput(this._devId)) {
      device = {
        deviceId: this._devId,
        platform: this._platform,
        token: this._token,
        uuid: this._devUUID,
      };
    } else {
      device = {
        platform: this._platform,
        token: this._token,
        uuid: this._devUUID,
      };
    }
    this.registerDevice(device);
  }

  // tslint:disable-next-line:member-ordering
  public registerDevice(device): void {
    console.log('Device details:', device);
    const xhr = this.setRequest(this.constants.getDevicesPath(), 'POST', true);

    /*this.http.post(this.constants.getDevicesPath(), device)
        .then((response) => {
            console.log('Response register,', response);
            localStorage.setItem('deviceId', response);
        });*/
    // tslint:disable-next-line:only-arrow-functions
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        console.log('Response register,', xhr);
        localStorage.setItem('deviceId', xhr.responseText);
      }
    };
    xhr.send(JSON.stringify(device));
  }

  // tslint:disable-next-line:member-ordering
  public unRegisterDevice(): Promise<any> {
    const promise = new Promise<void>((resolve, reject) => {
      this._devId = localStorage.getItem('deviceId');
      const global = this;
      // tslint:disable-next-line:only-arrow-functions
      navigator.serviceWorker.ready
        .then(function (registration) {
          registration
            .unregister()
            // tslint:disable-next-line:only-arrow-functions
            .then(function (checkUnregister) {
              if (!checkUnregister) {
                console.log('unregister failed');
                // tslint:disable-next-line:only-arrow-functions
                resolve();
              }
              global
                .unsubscribeDevice(global._devId, global)
                // tslint:disable-next-line:only-arrow-functions
                .then(function () {
                  resolve();
                });
            });
        })
        // tslint:disable-next-line:only-arrow-functions
        .catch(function (error) {
          console.log('Registration failed with ' + error);
          resolve();
        });
    });
    return promise;
  }

  // tslint:disable-next-line:member-ordering
  public unsubscribeDevice(deviceID, global): Promise<any> {
    const promise = new Promise<void>((resolve, reject) => {
      const device = {
        devices: {
          deviceId: global._devId,
          platform: global._platform,
          token: global._token,
          uuid: global._devUUID,
        },
      };
      if (deviceID) {
        const xhr = global.setRequest(global.constants.getDevicesPath() + '/' + deviceID, 'DELETE', true);
        // tslint:disable-next-line:only-arrow-functions
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4 && xhr.status === 200) {
            console.log('The response is ,', xhr);
            console.log('Successfully unregistered the device');
            localStorage.setItem('deviceUUID', '');
            localStorage.setItem('deviceId', '');
            localStorage.setItem('token', '');
            resolve();
          }
        };
        xhr.send(JSON.stringify(device));
      } else {
        resolve();
      }
    });
    return promise;
  }

  private setRequest(url, method, asyncP) {
    let xhr = new XMLHttpRequest();
    xhr.open(method, url, asyncP);
    xhr = this.setHeaders(xhr, method);
    return xhr;
  }

  private setHeaders(xhr, method) {
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('x-ibm-client-id', this.constants.getClientId());
    xhr.setRequestHeader('App-Code', this.constants.getAppCode());
    xhr.setRequestHeader('Accept-Language', this.constants.getAppLanguage());
    xhr.setRequestHeader('Authorization', this.constants.getAuthToken());
    xhr.setRequestHeader('jwt', this.constants.getJwt());
    xhr.timeout = 3000;

    if (method === 'POST' || method === 'PUT') {
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    }

    return xhr;
  }

  private generateUUID(token): string {
    let dateTime = new Date().getTime();
    if (window.performance && typeof window.performance.now === 'function') {
      dateTime += performance.now(); // use high-precision timer if available
    }

    const hostname = window.location.hostname;
    const arrayData = [];
    arrayData.push(this.hashCode(dateTime));
    arrayData.push(this.hashCode(token));
    arrayData.push(this.hashCode(hostname));
    arrayData.push(this.hashCode(this._platform));

    const finalString = arrayData.join('').replace(/[-.]/g, '').replace(/[,.]/g, '');
    let uuid = '';
    for (let i = 0; i < 32; i++) {
      uuid += finalString.charAt(Math.floor(Math.random() * finalString.length));
    }
    localStorage.setItem('deviceUUID', uuid);
    this._devUUID = uuid;
    return this._devUUID;
  }

  private hashCode(str): number {
    let hash = 0;
    let i;
    let chr;
    let len;
    if (str.length === 0) {
      return hash;
    }
    for (i = 0, len = str.length; i < len; i++) {
      chr = str.charCodeAt(i);
      // tslint:disable-next-line:no-bitwise
      hash = (hash << 5) - hash + chr;
      // tslint:disable-next-line:no-bitwise
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

  private validateInput(stringValue) {
    // tslint:disable-next-line:max-line-length
    return stringValue === undefined || stringValue == null || stringValue.length <= 0 || stringValue === ''
      ? false
      : true;
  }

  private urlB64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  }
}
